import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { ONBOARDING } from '../../lib/onboarding/formStyles'

interface OnboardingFieldProps {
  id: string
  label: ReactNode
  required?: boolean
  invalid?: boolean
  children: ReactNode
  className?: string
}

const OnboardingField = ({ id, label, required, invalid, children, className = '' }: OnboardingFieldProps) => {
  const { t } = useTranslation()

  return (
    <div
      id={`field-${id}`}
      className={`scroll-mt-32 space-y-2 rounded-2xl transition-shadow ${
        invalid ? 'ring-2 ring-kilo-danger/60 ring-offset-2 ring-offset-kilo-card' : ''
      } ${className}`}
    >
      <span className={ONBOARDING.label}>
        {label}
        {required ? (
          <>
            <span className="ml-1 text-kilo-danger" aria-hidden="true">
              *
            </span>
            <span className="sr-only"> ({t('onboarding.form.required')})</span>
          </>
        ) : null}
      </span>
      {children}
    </div>
  )
}

export default OnboardingField
